import * as React from 'react';

import SelectMultiple from './SelectMultiple';
import { SelectMultipleProps, ID, ValueType } from './model';

export type { SelectMultipleProps };

/**
 * SelectMultiple is an UI element to allow the user to make a selection out of the given <items>, by showing a list of
 *  <WBCheckbox> components for the given <items>. The user is able to select multiple items, the values are passed
 *  on to the given onChange event in the form of an array of all checked items' ids.
 *
 * Example usecases:
 * - Used on the timeslot-enabled 'create reservation' screen to filter floors, zones.
 *
 * @example
 * <WBSelectMultiple items={[
 *     {label: 'first option', id: 1},
 *     {label: 'second option', id: 2},
 * ]} value=2 />
 *
 */

type State = {
	internalValue: ValueType;
};

export class WBSelectMultiple extends React.Component<SelectMultipleProps, State> {
	constructor(props: SelectMultipleProps) {
		super(props);

		this.state = {
			internalValue: props.value && props.value.length ? props.value : [],
		};
	}

	onCheckboxChange(id: ID, checked: boolean) {
		const { onChange } = this.props;
		const { internalValue } = this.state;

		const newInternalValue = checked ? this.addValue(internalValue, id) : this.removeValue(internalValue, id);

		this.setState({ internalValue: newInternalValue }, () => onChange && onChange(newInternalValue));
	}

	addValue(currentValue: ValueType, id: ID) {
		currentValue.push(id);

		return currentValue;
	}

	removeValue(currentValue: ValueType, id: ID) {
		const newValue = currentValue.filter((value) => {
			return value !== id;
		});

		return newValue;
	}

	render() {
		return (
			<SelectMultiple
				items={this.props.items}
				internalValue={this.state.internalValue}
				onCheckboxChange={this.onCheckboxChange.bind(this)}
			/>
		);
	}
}
